import {Module} from '@fantasmagames/slot/src/common/Module';
import {WinPresentationView} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationView';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {WinPresentationBasicState} from '@fantasmagames/slot/src/modules/winpresentation/states/WinPresentationBasicState';
import {WinPresentationInitialState} from '@fantasmagames/slot/src/modules/winpresentation/states/WinPresentationInitialState';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';
import {SwipeInteractionEvents} from '@fantasmagames/slot/src/modules/swipeinteraction/SwipeInteractionEvents';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {BetlevelMenuEvents} from '@fantasmagames/slot/src/modules/popupmenus/betmenu/BetlevelMenuEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {WinPresentationDebuggingComponent} from '@fantasmagames/slot/src/modules/winpresentation/debuggingComponent/WinPresentationDebuggingComponent';
import {WinPresentationIndividualState} from '@fantasmagames/slot/src/modules/winpresentation/states/WinPresentationIndividualState';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {WinPresentationInitialBeforeBigWin} from '@fantasmagames/slot/src/modules/winpresentation/states/WinPresentationInitialBeforeBigWin';
import {WinPresentationSkippedState} from '@fantasmagames/slot/src/modules/winpresentation/states/WinPresentationSkippedState';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';

/**
 * responsible for win presentation on symbols and win number
 */
export class WinPresentationModule extends Module<WinPresentationView> {
	public static readonly BASIC: string = 'basic';
	public static readonly INDIVIDUAL: string = 'individual';
	public static readonly INITIAL: string = 'initial';
	public static readonly INITIALBEFOREBIGWIN: string = 'initialbeforebigwin';
	public static readonly SKIPPED: string = 'skipped';

	protected enterFirstState(): void {
		this.changeStateTo(WinPresentationModule.BASIC);
	}

	protected setupStates(): void {
		this.addState(new WinPresentationBasicState(this, WinPresentationModule.BASIC));
		this.addState(new WinPresentationIndividualState(this, WinPresentationModule.INDIVIDUAL));
		this.addState(new WinPresentationInitialState(this, WinPresentationModule.INITIAL));
		this.addState(new WinPresentationInitialBeforeBigWin(this, WinPresentationModule.INITIALBEFOREBIGWIN));
		this.addState(new WinPresentationSkippedState(this, WinPresentationModule.SKIPPED));
	}

	protected setupViews(): void {
		if (this.system.shouldUseMultipleViews()) {
			this.setView(Views.WIN_PRESENTATION_VIEW_MOBILE);
		} else {
			this.setView(Views.WIN_PRESENTATION_VIEW);
		}
	}

	public addDebuggingComponent(): void {
		new WinPresentationDebuggingComponent(this, this.view);
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.onCurrentStateHandle(ReelsEvents.REELS_SPINNING_STARTED);
		this.onCurrentStateHandle(AvalancheReelsEvents.REMOVING_AVALANCE_SYMBOLS_STARTED);
		this.onCurrentStateHandle(SwipeInteractionEvents.DRAGGING_STARTED);
		this.onCurrentStateHandle(BetlevelMenuEvents.BET_VALUE_UPDATED);
		this.onCurrentStateHandle(FlowModuleEvents.WON);
		this.onCurrentStateHandle(WinPresentationEvents.WIN_NUMBER_BOUNCE_FINISHED);
		this.onCurrentStateHandle(WinPresentationEvents.WIN_NUMBER_SHOWN_TO_PLAYER);
		this.onCurrentStateHandle(SpinButtonEvents.QUICKSTOP_PRESSED);
		this.onCurrentStateHandle(WinPresentationEvents.COUNTUP_FINISHED);

		this.onView(WinPresentationView.COUNTUP_ANIMATION_FINISHED, this.onEndAnimationFinished);
		this.onViewEmitEvent(WinPresentationView.COUNTUP_ANIMATION_STARTED, WinPresentationEvents.COUNTUP_STARTED);
		this.onViewEmitEvent(WinPresentationView.WIN_NUMBER_SHOWN_TO_PLAYER, WinPresentationEvents.WIN_NUMBER_SHOWN_TO_PLAYER);
		this.onViewEmitEvent(WinPresentationView.WIN_NUMBER_BOUNCE_FINISHED, WinPresentationEvents.WIN_NUMBER_BOUNCE_FINISHED);
		this.onViewEmitEvent(WinPresentationView.INITIAL_WIN_ANIMATION_FINISHED, WinPresentationEvents.INITIAL_WIN_ANIMATION_FINISHED);

		this.onViewCurrentStateHandle(WinPresentationView.WIN_ANIMATION_FINISHED);

		this.on(FlowModuleEvents.START_INDIVIDUAL_WIN, this.onShouldStartIndividualWin);

		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);

		this.on(BetlevelMenuEvents.BET_LEVEL_MENU_SELECTED_BET_ACCEPTED, this.onBetChanged);
	}

	protected onEndAnimationFinished(): void {
		this.eventManager.emit(WinPresentationEvents.COUNTUP_FINISHED);
		this.currentState.handle(WinPresentationView.COUNTUP_ANIMATION_FINISHED);
	}

	protected onFreeSpinsOutroStarted(): void {
		this.view.forceKillWinNumbers();
		this.view.killCurrentWinPresentation();
		this.gotoState(WinPresentationModule.BASIC);
	}

	protected onFreeSpinsIntroStarted(): void {
		this.view.forceKillWinNumbers();
		this.view.killCurrentWinPresentation();
		this.gotoState(WinPresentationModule.BASIC);
	}

	protected onShouldStartIndividualWin(): void {
		this.gotoState(WinPresentationModule.INDIVIDUAL);
	}

	protected onBetChanged(): void {
		this.gotoState(WinPresentationModule.BASIC);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/winpresentation/WinPresentationModule.ts